import type { RegulatoryDocumentType } from '@/@types/Products';

export const REQUIRED_CREATE_PRODUCT_REGULATORY_TYPES = [
  'contract',
  'coa',
  'label',
] as const satisfies readonly RegulatoryDocumentType[];

export const REGULATORY_DOCUMENT_TYPE_VALUES: RegulatoryDocumentType[] = [
  'contract',
  'coa',
  'label',
  'manufacturing_license',
  'other',
];

export function getRegulatoryDocumentTypeOptions(
  t: (key: string) => string,
): { value: RegulatoryDocumentType; label: string }[] {
  return REGULATORY_DOCUMENT_TYPE_VALUES.map((value) => ({
    value,
    label: t(`regulatoryDocumentType_${value}`),
  }));
}
